import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { LifecyclesService } from '../lifecycle/lifecycle.service';

@Injectable({ providedIn: 'root' })
export class SelectionCacheService {
  private cache = new Map<string, Record<string, unknown>>();

  constructor(lifecyclesService: LifecyclesService) {
    lifecyclesService.addPreLogoutHook(() => {
      this.clearAll();
      return of(undefined);
    });
  }

  save(componentId: string, selections: Record<string, unknown>): void {
    this.cache.set(componentId, selections);
  }

  get(componentId: string): Record<string, unknown> | undefined {
    return this.cache.get(componentId);
  }

  clearAll(): void {
    this.cache.clear();
  }
}
